import { FC } from "react";
import ConfigurationHistoryTable from "../components/history-table/configuration-history-table.component";
import {
  getAssetGeneralConfigurationHistory,
  getAssetGeneralConfigurationHistoryDetail,
} from "src/core/api/services/command-module/general-config.service";

interface ConfigurationHistoryTableComponentType {
  isOpen: boolean;
  handleClose: () => void;
  assetCode: string | null;
  applyingChangesACKStatus: "idle" | "pending" | "success" | "failed";
}

const ConfigurationHistoryTableComponent: FC<
  ConfigurationHistoryTableComponentType
> = ({ isOpen, handleClose, assetCode, applyingChangesACKStatus }) => (
  <ConfigurationHistoryTable
    isOpen={isOpen}
    handleClose={handleClose}
    assetCode={assetCode}
    title="Command History"
    subtitle="Last 13 months"
    retainedText="Retained for 13 Months"
    actionColumnTitle="Configuration Action"
    actionTitleField="title"
    issueTimeField="sentOn"
    acknowledgeTimeField="ackTime"
    defaultSortBy="SentOn"
    queryKey="getAssetGeneralConfigurationHistory"
    getHistory={getAssetGeneralConfigurationHistory}
    getHistoryDetail={getAssetGeneralConfigurationHistoryDetail}
    refetchTrigger={applyingChangesACKStatus}
  />
);

export default ConfigurationHistoryTableComponent;
